(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["studio-study-viewer"] && !Shopify.designMode) return;
  try {
    (() => {
  document.querySelectorAll('[data-study-demo]').forEach((demo) => {
    const toolbar = demo.querySelector('[data-study-toolbar]');
    const panels = [...demo.querySelectorAll('[data-study-panel]')];
    const versions = [...demo.querySelectorAll('[data-study-version]')];
    const devices = [...demo.querySelectorAll('[data-study-device]')];
    if (!toolbar || panels.length !== 2) return;
    let version = 'after';
    let device = window.matchMedia('(max-width: 600px)').matches ? 'mobile' : 'desktop';
    let scheduled = false;
    const measure = () => {
      scheduled = false;
      const panel = panels.find((item) => item.dataset.studyPanel === version);
      const stage = panel.querySelector('[data-study-stage]');
      const width = stage.clientWidth;
      if (!width) return;
      const base = device === 'mobile' ? 390 : 1180;
      const scale = Math.min(1, width / base);
      stage.style.setProperty('--study-frame-width', `${base}px`);
      stage.style.setProperty('--study-frame-scale', String(scale));
      stage.style.setProperty('--study-frame-height', `${860 * scale + 2}px`);
    };
    const scheduleMeasure = () => {
      if (!scheduled) {
        scheduled = true;
        requestAnimationFrame(measure);
      }
    };
    const refresh = () => {
      demo.dataset.device = device;
      panels.forEach((panel) => { panel.hidden = panel.dataset.studyPanel !== version; });
      versions.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.studyVersion === version)));
      devices.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.studyDevice === device)));
      scheduleMeasure();
    };
    versions.forEach((button) => button.addEventListener('click', () => {
      version = button.dataset.studyVersion;
      refresh();
    }));
    devices.forEach((button) => button.addEventListener('click', () => {
      device = button.dataset.studyDevice;
      refresh();
    }));
    demo.dataset.enhanced = 'true';
    toolbar.hidden = false;
    refresh();
    if ('ResizeObserver' in window) new ResizeObserver(scheduleMeasure).observe(demo);
    else window.addEventListener('resize', scheduleMeasure);
    const disclosure = demo.closest('details');
    if (disclosure) disclosure.addEventListener('toggle', scheduleMeasure);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
